import Text from '@/components/basic/text';
import theme from '@/style';
import React, {FC, useEffect} from 'react';
import {ImageRequireSource, View} from 'react-native';
import {Image as AntdImage} from 'antd-mobile';
import {BasicObject, NavigatorScreenProps} from '@/types';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import {
  BottomTabNavigationOptions,
  createBottomTabNavigator,
} from '@react-navigation/bottom-tabs';
import Home from './pages/home';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {Shadow} from 'react-native-shadow-2';
import Me from './pages/me';
// import Promotion from '@/common-pages/promotion';
// import Casino from './pages/casino';
// import LiveCasino from './pages/live-casino';
import {toAgentApply} from './utils';
import homeIcon from '@assets/icons/main-tab/Home_new.webp';
import homeActiveIcon from '@assets/icons/main-tab/home_.webp';
// import sportIcon from '@assets/icons/main-tab/sports_.webp';
// import sportActiveIcon from '@assets/icons/main-tab/sports_active.webp';
// import liveIcon from '@assets/icons/main-tab/live_casino_.webp';
// import liveActiveIcon from '@assets/icons/main-tab/live_casino_active.webp';
// import casinoIcon from '@assets/icons/main-tab/casino_.webp';
// import casinoActiveIcon from '@assets/icons/main-tab/casino_active.webp';
import promotionsIcon from '@assets/icons/main-tab/promotions.webp';
import promotionsActiveIcon from '@assets/icons/main-tab/promotions-active.webp';
import {ReactComponent as ReferralSvg} from '@/assets/icons/main-nav/referral.svg';
import meIcon from '@assets/icons/main-tab/me_.webp';
import meActiveIcon from '@assets/icons/main-tab/me_active.webp';
import chatIcon from '@assets/icons/main-tab/chat_.webp';
import chatActiveIcon from '@assets/icons/main-tab/chat_active.webp';

// import IMWebView from './common-pages/im/im-webview';
// import {toAgentApply} from '@/utils';
// import {toChat} from '@/common-pages/game-navigate';

const Tab = createBottomTabNavigator();

// const homeIcon = require('@assets/icons/main-tab/home-new-2.webp');
// const homeActiveIcon = require('@assets/icons/main-tab/home_.webp');
// const sportIcon = require('@assets/icons/main-tab/sports_.webp');
// const sportActiveIcon = require('@assets/icons/main-tab/sports_active.webp');
// const liveIcon = require('@assets/icons/main-tab/live_casino_.webp');
// const liveActiveIcon = require('@assets/icons/main-tab/live_casino_active.webp');
// const casinoIcon = require('@assets/icons/main-tab/casino_.webp');
// const casinoActiveIcon = require('@assets/icons/main-tab/casino_active.webp');
// const meIcon = require('@assets/icons/main-tab/me_.webp');
// const meActiveIcon = require('@assets/icons/main-tab/me_active.webp');
// const chatIcon = require('@assets/icons/main-tab/chat_.webp');
// const chatActiveIcon = require('@assets/icons/main-tab/chat_active.webp');
import IMWebView from './common-pages/im/im-webview';
import Promotions from './pages/promotions';
import Agent from './pages/agent';
import {goTo} from './utils';
import {homePage} from './config';
import {runWhenBrowserIdle} from '@/utils/defer';

const loadSportsContainer = () => import('./common-pages/sports/container');

const shadow = {
  startColor: '#0004',
  distance: 1,
  offset: [0, 0],
  style: [
    theme.flex.row,
    theme.flex.around,
    theme.background.dark,
    theme.fill.fillW,
    {
      height: '3.125rem',
    },
  ] as BasicObject[],
} as BasicObject;

if (globalStore.isWeb) {
  shadow.distance = 0;
  delete shadow.offset;
  shadow.style.push({
    boxShadow: '0 0 1px 0px #0004',
  });
}

export const mainPageList: {
  name: string;
  link: string;
  component: (props: NavigatorScreenProps) => React.JSX.Element;
  img?: ImageRequireSource | string;
  activeImg?: ImageRequireSource | string;
  unmountOnBlur?: boolean;
  lazy?: boolean;
  params?: BasicObject;
  svgIcon?: ({active}: {active: boolean}) => React.ReactNode;
}[] = [
  {
    name: 'Home',
    link: 'index/home',
    component: Home,
    img: homeIcon,
    activeImg: homeActiveIcon,
  },
  {
    name: 'Promotions',
    link: 'index/promotions',
    component: Promotions,
    img: promotionsIcon,
    activeImg: promotionsActiveIcon,
  },
  {
    name: 'EarnMoney',
    link: 'index/earnmoney',
    component: Agent,
    svgIcon: ({active}) => (
      <ReferralSvg
        style={{
          color: active ? 'var(--1)' : 'var(--T3)',
          width: '1.5rem',
          height: '1.5rem',
        }}
      />
    ),
  },
  {
    name: 'Chat',
    link: 'index/chat',
    component: IMWebView,
    img: chatIcon,
    activeImg: chatActiveIcon,
    lazy: false,
  },

  // {
  //   name: 'ProxyHome',
  //   link: 'index/proxy-home',
  //   component: ProxyHome,
  //   svgIcon: AgentIcon,
  //   params: {
  //     hideBack: true,
  //   },
  // },
  {
    name: 'Me',
    link: 'index/me',
    component: Me,
    img: meIcon,
    activeImg: meActiveIcon,
  },
];

const CusDefautTab = ({
  index,
  label,
  isFocused,
  options,
  onPress,
  count,
}: {
  index: number;
  label: string;
  isFocused: boolean;
  options: BottomTabNavigationOptions;
  onPress: (isFocused: boolean) => void;
  count?: number;
}) => {
  return (
    <NativeTouchableOpacity
      activeOpacity={0.8}
      accessibilityRole="button"
      accessibilityState={isFocused ? {selected: true} : {}}
      accessibilityLabel={options?.tabBarAccessibilityLabel}
      testID={options?.tabBarTestID}
      onPress={() => onPress(isFocused)}
      style={[
        theme.flex.center,
        theme.flex.flex1,
        theme.padding.tbs,
        theme.position.rel,
        theme.overflow.visible,
      ]}>
      <View style={[theme.position.rel]}>
        {mainPageList[index].svgIcon != null ? (
          mainPageList[index].svgIcon?.({active: isFocused})
        ) : (
          <>
            <AntdImage
              style={{
                ...theme.icon.l,
                visibility: isFocused ? 'visible' : 'hidden',
                width: !isFocused ? 0 : '1.5rem',
                height: !isFocused ? 0 : '1.5rem',
              }}
              src={mainPageList[index].activeImg?.toString()}
              lazy={true}
            />
            <AntdImage
              style={{
                ...theme.icon.l,
                visibility: !isFocused ? 'visible' : 'hidden',
                width: isFocused ? 0 : '1.5rem',
                height: isFocused ? 0 : '1.5rem',
              }}
              src={mainPageList[index].img?.toString()}
              lazy={true}
            />
          </>
        )}
        {/* !!count && count > 0 &&  */}
        {!!count && count > 0 && (
          <View
            style={[
              theme.flex.center,
              theme.position.abs,
              {
                paddingHorizontal: 5,
                paddingVertical: 2,
                borderWidth: 1,
                borderColor: '#000',
                borderRadius: 9999,
                backgroundColor: '#DC083B',
                left: 15,
                top: -4,
              },
            ]}>
            <Text
              fontSize={10}
              fontFamily="fontDin"
              blod
              color={theme.basicColor.white}>
              {count && count > 99 ? '99+' : count}
            </Text>
          </View>
        )}
      </View>

      <Text
        blod={isFocused}
        fontSize={10}
        style={{
          color: isFocused ? 'var(--1)' : 'var(--T3)',
          marginTop: 4,
        }}>
        {label}
      </Text>
    </NativeTouchableOpacity>
  );
};

interface TabBarListItem {
  name: string;
  options?: BottomTabNavigationOptions;
}
interface TabBarListProps {
  list: TabBarListItem[];
  activeIndex: number;
}

export const TabBarList: FC<TabBarListProps> = ({list, activeIndex}) => {
  const [imCount, setImCount] = React.useState<number>(0);
  // const [token, setToken] = useState('');
  useEffect(() => {
    const countStr = localStorage.getItem('imCount') || '0';
    setImCount(Number(countStr));
    const sub = globalStore.chatNumSubject.subscribe(count => {
      setImCount(count);
    });
    // const tokenSub = globalStore.tokenSubject.subscribe(_token => {
    //   setToken(_token || '');
    // });
    return () => {
      sub.unsubscribe();
      // tokenSub.unsubscribe();
    };
  }, []);
  return (
    <Shadow containerViewProps={{id: 'tabbar-container'}} {...shadow}>
      {list.map((item, index) => {
        const onPress = (isFocused: boolean) => {
          if (isFocused) {
            return;
          }
          if (item.name === 'Promotions') {
            goTo('PromotionsV2');
            return;
          }
          if (item.name === 'ProxyHome') {
            if (globalStore.userInfo?.isAgent !== 1) {
              return toAgentApply();
            }
          }
          if (item.name === 'EarnMoney') {
            goTo('EarnMoney', {
              tabKey: 'invitation-reward',
            });
            return;
          }
          // if (item.name === 'Chat' && !token) {
          //   goTo('Login', {
          //     backPage: homePage,
          //     sucessPage: homePage,
          //     sucessPageParams: {
          //       screen: 'Chat',
          //     },
          //   });
          //   return;
          // }
          if (item.name === 'Sports') {
            globalStore.openSports.next(undefined);
            return;
          }
          goTo(homePage, {
            screen: item.name,
          });
        };
        return (
          <CusDefautTab
            key={item.name}
            index={index}
            label={(item.options?.title as string) || item.name}
            isFocused={activeIndex === index}
            options={item.options || {}}
            onPress={onPress}
            count={item.name === 'Chat' ? imCount : 0}
          />
        );
      })}
    </Shadow>
  );
};

const MainNav = () => {
  const {i18n} = useTranslation();

  useEffect(() => {
    runWhenBrowserIdle(() => {
      loadSportsContainer().catch(() => {});
    }, 3000);
  }, []);

  return (
    <Tab.Navigator
      // eslint-disable-next-line react/no-unstable-nested-components
      tabBar={props => {
        return (
          <TabBarList
            list={props.state.routes.map(route => {
              const {options} = props.descriptors[route.key];
              return {
                name: route.name,
                options: options,
              };
            })}
            activeIndex={props.state.index}
          />
        );
      }}
      backBehavior="none"
      screenOptions={{
        headerShown: false,
      }}>
      {mainPageList.map(v => (
        <Tab.Screen
          key={v.name}
          name={v.name}
          component={v.component}
          options={{
            title: i18n.t(`home.tab.${v.name.toLocaleLowerCase()}`),
            unmountOnBlur: v.unmountOnBlur,
            lazy: v.lazy,
          }}
          initialParams={v.params}
        />
      ))}
    </Tab.Navigator>
  );
};

export default MainNav;
